import React, {useEffect, useLayoutEffect, useState} from 'react';
import {
	findUsers,
	usersListFilteredLicense as setUsersListFilteredLicense, usersListFilteredRole as setUsersListFilteredRole,
	usersListFilteredStatus as setUsersListFilteredStatus
} from '../../../../../actions/usersListActions';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import Stats from "./components/stats";
import DataList from "../../../../components/data-list";
import DataListHead from "../../../../components/data-list/data-list-head";
import UserListSearch from "./components/users-list-search";
import Icon from "../../../../components/icon";
import LabelSearch from "./components/label-search";
import UserListContent from "./components/users-list-content";
import Button from "../../../../components/button";
import {dropDownPosition} from "../../../../utils";
import {isUserListAddCollaboratorsPopupShown} from "../../../../../actions/popupActions";
import SharingDetailsPopup from "../../../sharing/components/sharing-details-popup";
import './index.css';

function UsersList () {

    const [displayStatusFilter, setDisplayStatusFilter] = useState(false);
    const [displayLicenseFilter, setDisplayLicenseFilter] = useState(false);

    const usersListFilteredStatus = useSelector(state => state.usersListReducer.usersListFilteredStatus);
    const usersListFilteredLicense = useSelector(state => state.usersListReducer.usersListFilteredLicense);
	const usersListFilteredRole = useSelector(state => state.usersListReducer.usersListFilteredRole);

    const dispatch = useDispatch();

    const { t } = useTranslation();

    useLayoutEffect(() => {
	    dropDownPosition(document.querySelector(".data-list__head"), document.querySelector(".data-list__head .filter-status"), document.querySelector(".data-list__head ul"));
    }, [displayStatusFilter]);

	useLayoutEffect(() => {
		dropDownPosition(document.querySelector(".data-list__head"), document.querySelector(".data-list__head .filter-license"), document.querySelector(".data-list__head ul"));
	}, [displayLicenseFilter]);

	useEffect(() => {
		dispatch(findUsers())
	}, [dispatch]);

    const displayUsersListFilteredStatus = (e) => {

	    const value = e.currentTarget.dataset.value;

	    if(usersListFilteredRole !== null){
		    if(usersListFilteredLicense !== null) {
			    dispatch(findUsers(value, usersListFilteredLicense, usersListFilteredRole));
		    } else {
			    dispatch(findUsers(value, usersListFilteredRole));
		    }
	    } else {
		    if(usersListFilteredLicense !== null) {
			    dispatch(findUsers(value, usersListFilteredLicense));
		    } else {
			    dispatch(findUsers(value));
		    }
	    }


        dispatch(setUsersListFilteredStatus(value));

    };

    const displayUsersListFilteredLicense = (e) => {

	    const value = e.currentTarget.dataset.value;

	    if(usersListFilteredRole !== null){
		    if(usersListFilteredStatus !== null){
			    dispatch(findUsers(usersListFilteredStatus, value, usersListFilteredRole));
		    } else {
			    dispatch(findUsers(null, value, usersListFilteredRole));
		    }
	    } else {
		    if(usersListFilteredStatus !== null){
			    dispatch(findUsers(usersListFilteredStatus, value, usersListFilteredRole));
		    } else {
			    dispatch(findUsers(null, value, usersListFilteredRole));
		    }
	    }


        dispatch(setUsersListFilteredLicense(value));
    };

    const removeStatusFilter = (e) => {
        e.stopPropagation();
        dispatch(setUsersListFilteredStatus(null));
        if(usersListFilteredRole !== null){
	        if(usersListFilteredLicense !== null){
		        dispatch(findUsers(null, usersListFilteredLicense, usersListFilteredRole));
	        } else {
		        dispatch(findUsers(null, null, usersListFilteredRole));
	        }
        } else {
	        if(usersListFilteredLicense !== null){
		        dispatch(findUsers(null, usersListFilteredLicense));
	        } else {
		        dispatch(findUsers());
	        }
        }
    };

    const removeLicenseFilter = (e) => {
        e.stopPropagation();
        dispatch(setUsersListFilteredLicense(null));
	    if(usersListFilteredRole !== null){
		    if(usersListFilteredStatus !== null){
			    dispatch(findUsers(usersListFilteredStatus, null, usersListFilteredRole));
		    } else {
			    dispatch(findUsers(null, null, usersListFilteredRole));
		    }
	    } else {
		    if(usersListFilteredStatus !== null){
			    dispatch(findUsers(usersListFilteredStatus));
		    } else {
			    dispatch(findUsers());
		    }
	    }

    };

    const handlerStatusFilter = () => {
    	if(!displayStatusFilter){
		    setDisplayStatusFilter(true);
	    } else {
		    setDisplayStatusFilter(false);
	    }
    };

    const handlerLicenseFilter = () => {
	    if(!displayLicenseFilter){
		    setDisplayLicenseFilter(true);
	    } else {
		    setDisplayLicenseFilter(false);
	    }
    };

    const mouseLeaveHandler = () => {
        setDisplayStatusFilter(false);
        setDisplayLicenseFilter(false);
    };

    const handleAddCollaborator = () => {
        dispatch(isUserListAddCollaboratorsPopupShown(true));
    };

    const handleClickFilterRole = (value) => {

	    dispatch(setUsersListFilteredRole(value));

    	if(value){
		    if(usersListFilteredLicense){
			    if(usersListFilteredStatus !== null){
				    dispatch(findUsers(usersListFilteredStatus, usersListFilteredLicense, value));
			    } else {
				    dispatch(findUsers(null, usersListFilteredLicense, value));
			    }
		    } else {
			    if(usersListFilteredStatus !== null){
				    dispatch(findUsers(usersListFilteredStatus, null, value));
			    } else {
				    dispatch(findUsers(null, null, value));
			    }
		    }
	    } else {
		    if(usersListFilteredLicense){
			    if(usersListFilteredStatus !== null){
				    dispatch(findUsers(usersListFilteredStatus, usersListFilteredLicense));
			    } else {
				    dispatch(findUsers(null, usersListFilteredLicense));
			    }
		    } else {
			    if(usersListFilteredStatus !== null){
				    dispatch(findUsers(usersListFilteredStatus, null));
			    } else {
				    dispatch(findUsers());
			    }
		    }
	    }
    };

    return (
        <div className="users-list container p-4">
            <h2>Users & Licenses</h2>
            <h3>Manage your users and licenses</h3>
            <Stats/>
			<SharingDetailsPopup/>
            <div className="my-3 d-flex align-items-center">
	            <div className="col-6 tabs">
		            <ul className="nav nav-pills">
			            <li className="nav-item">
				            <Button onClick={ () => handleClickFilterRole(null) } className={`nav-link${usersListFilteredRole === null ? ' active' : ''}`}>View all</Button>
			            </li>
			            <li className="nav-item">
				            <Button onClick={ () => handleClickFilterRole('USER') } className={`nav-link${usersListFilteredRole === "USER" ? ' active' : ''}`}>User</Button>
			            </li>
			            <li className="nav-item">
				            <Button onClick={ () => handleClickFilterRole('ADMINISTRATOR') } className={`nav-link${usersListFilteredRole === "ADMINISTRATOR" ? ' active' : ''}`}>Admin</Button>
			            </li>
		            </ul>
                </div>
                <div className="col-6">
	                <Button className="btn-link font-weight-normal p-0" onClick={handleAddCollaborator}>
		                <svg className="align-text-top mr-2" width="21px" height="21px" viewBox="0 0 21 21">
			                <path fill="#090" d="M10.5,21C4.7,21,0,16.3,0,10.5C0,4.7,4.7,0,10.5,0C16.3,0,21,4.7,21,10.5
								C21,16.3,16.3,21,10.5,21z M10.5,1C5.2,1,1,5.2,1,10.5c0,5.3,4.3,9.5,9.5,9.5c5.3,0,9.5-4.3,9.5-9.5C20,5.2,15.8,1,10.5,1z
								 M11.8,16.3H9.2v-4.5H4.7V9.2h4.5V4.7h2.6v4.5h4.5v2.6h-4.5V16.3z"/>
		                </svg>
		                Add a licensed user
	                </Button>

                </div>
            </div>
            <DataList className={`users-list`}>
                <DataListHead>
                    <div className="col-3">
                        <UserListSearch/>
                    </div>
                    <div className="col-1">
                        Role
                    </div>
                    <div className="filter-status col-2 text-center"
                         onClick={handlerStatusFilter} onMouseLeave={mouseLeaveHandler}>
                        {t("popupSharingStatus")}
                        {usersListFilteredStatus === null && <Icon className="ml-1" name="filter"/>}
                        {
	                        displayStatusFilter && <ul>
                                <li><Button className="btn-link" data-value="normal" onClick={displayUsersListFilteredStatus}><Icon name="check"/> {t("normalText")}</Button></li>
                                <li><Button className="btn-link" data-value="deleted" onClick={displayUsersListFilteredStatus}><Icon name="user-times"/>{t("UserDeletedText")}</Button></li>
                                <li><Button className="btn-link" data-value="suspended" onClick={displayUsersListFilteredStatus}><Icon name="minus-circle"/> {t("UserSuspendedText")}</Button></li>
                                <li><Button className="btn-link" data-value="banned" onClick={displayUsersListFilteredStatus}><Icon name="gavel"/> {t("UserBannedText")}</Button></li>
                                <li><Button className="btn-link" data-value="revoked" onClick={displayUsersListFilteredStatus}><Icon name="times-circle"/> {t("UserRevokedText")}</Button></li>
                                <li><Button className="btn-link" data-value="invitationPending" onClick={displayUsersListFilteredStatus}><Icon name="clock-o"/> {t("InviteSentText")}</Button></li>
                                <li><Button className="btn-link" data-value="unknown" onClick={displayUsersListFilteredStatus}><Icon name="question-circle-o"/> {t("adminScreenStatus8")}</Button></li>
                            </ul>
                        }
                        {
                            usersListFilteredStatus !== null
                                ?
                                <div className="status">
                                    {usersListFilteredStatus === "normal" ? <Icon name="check"/> : ""}
                                    {usersListFilteredStatus === "deleted" ? <Icon name="user-times"/> : ""}
                                    {usersListFilteredStatus === "suspended" ? <Icon name="minus-circle"/> : ""}
                                    {usersListFilteredStatus === "banned" ? <Icon name="gavel"/> : ""}
                                    {usersListFilteredStatus === "revoked" ? <Icon name="times-circle"/> : ""}
                                    {usersListFilteredStatus === "invitationPending" ? <Icon name="clock-o"/> : ""}
                                    {usersListFilteredStatus === "unknown" ? <Icon name="question-circle-o"/> : ""}
                                    <span onClick={removeStatusFilter} className="delete">×</span>
                                </div>
                                :
                                ""
                        }
                    </div>
                    <div className="filter-license col-1 text-center" onClick={handlerLicenseFilter}
                         onMouseLeave={mouseLeaveHandler}>
                        {t("textLicensed")}
                        {usersListFilteredLicense === null && <Icon className="ml-1" name="filter"/>}
                        {
	                        displayLicenseFilter && <ul>
                                <li><Button className="btn-link" data-value="licensed" onClick={displayUsersListFilteredLicense}><Icon name="check"/> {t("textLicensed")}</Button></li>
                                <li><Button className="btn-link" data-value="unusedLicense" onClick={displayUsersListFilteredLicense}><Icon name="times"/> {t("textUnusedLicense")}</Button></li>
                            </ul>
                        }
                        {
                            usersListFilteredLicense !== null
                                ?
                                <div className="status">
                                    {usersListFilteredLicense === "licensed" ? <Icon name="check"/> : ""}
                                    {usersListFilteredLicense === "unusedLicense" ? <Icon name="times"/> : ""}
                                    <span onClick={removeLicenseFilter} className="delete">×</span>
                                </div>
                                :
                                ""
                        }
                    </div>
                    <div className="col-1 "/>
                    <div className="col-2">
                        <LabelSearch/>
                    </div>
                </DataListHead>
                <UserListContent/>
            </DataList>
        </div>
    )
}

export default UsersList;
